module.exports = __webpack_public_path__ + "static/media/journal_notes.4c9a666c.svg";